import {create} from 'zustand';

import {MapService} from '@/models/dto/map/map-service';

interface BaseLayerState {
  baseLayers: MapService[];
  activeBaseLayer?: MapService;
  setBaseLayers: (layers: MapService[]) => void;
  setBaseLayerById: (id: number) => void;
  setBaseLayer: (layer: MapService) => void;
}

export const useBaseLayerStore = create<BaseLayerState>((set, get) => ({
  baseLayers: [],
  activeBaseLayer: undefined,

  setBaseLayers: (layers) => {
    set({
      baseLayers: layers,
      activeBaseLayer: layers.find((l) => l.isDefault)
    });
  },

  setBaseLayerById: (id) => {
    const layer = get().baseLayers.find((l) => l.id === id);
    if (layer) set({activeBaseLayer: layer});
  },

  setBaseLayer: (layer) => set({activeBaseLayer: layer})
}));
